import { createFileRoute } from "@tanstack/react-router";
import { RunsPage } from "../features/agent/RunsPage";

export const Route = createFileRoute("/w/$ws/runs")({ component: RunsPage });
